// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RotateLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/RotateLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RotateLeftOutlinedSvg
  }));
};

RotateLeftOutlined.displayName = 'RotateLeftOutlined';
export default /*#__PURE__*/React.forwardRef(RotateLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/RotateLeftOutlined.js
// module id = 931
// module chunks = 0